export default "/images/vendor/flag-icons/flags/1x1/jp.svg?5d4d1d1eeb3d4c9ca3740c294ec0c41e";